import { useState, useEffect } from 'react';
import fetch from 'unfetch';
import { dsvFormat } from 'd3-dsv';

export default (fileName, delimiter = ',', parseRow = r => r) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const csv = dsvFormat(delimiter);
      const response = await fetch(`data/${fileName}`);
      const csvString = await response.text();

      setData(csv.parse(csvString, parseRow));
    };

    loadData();
  }, []);

  return data;
};
